import { createFileRoute } from '@tanstack/react-router';
import { withModalOutlet } from '../-withModalOutlet';
import UserGroups from '../../../administration/src/components/MetaSites/MetaSiteDetails/Permissions/UserGroups';

export const Route = createFileRoute('/_secured/administration/meta-sites/$metaSiteId/permissions/user-groups/$page/$limit')({
  component: withModalOutlet(UserGroups),
});
